import { reatomAsync, withDataAtom, withAbort } from "@reatom/async";
import { CategoryDto } from "definitions/product-storage/models/category-dto";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import { axiosErrorHandler } from "src/util";

export const getCategoriesFetch = reatomAsync(async (ctx) => {
  return API.categoriesApi
    .categoryControllerGetCategoriesTree(
      { hideEmpty: true, withCount: true },
      { signal: ctx.controller.signal },
    )
    .then((res) => {
      const result = new Array<CategoryDto>();
      const categoriesPidMap = new Map<number, CategoryDto[]>();
      for (const category of res.data) {
        const parentId = (category.parentId as unknown as number) ?? 0;
        if (!categoriesPidMap.has(parentId)) categoriesPidMap.set(parentId, []);
        if (category.id !== undefined) {
          categoriesPidMap.get(parentId)?.push(category);
        }
      }

      for (const category1 of categoriesPidMap.get(0) ?? []) {
        result.push(category1);
        if (category1.id !== undefined) {
          for (const category2 of categoriesPidMap.get(category1.id) ?? []) {
            result.push(category2);
            if (category2.id !== undefined) {
              result.push(...(categoriesPidMap.get(category2.id) ?? []));
            }
          }
        }
      }

      return result;
    })
    .catch(axiosErrorHandler);
}, "fetchCategories").pipe(
  withDataAtom(null),
  withAbort(),
  withIsLoadingAtom(),
);
